var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalStudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.173 19.9081L19.3806 20.0031L19.5884 19.9085L28.7673 15.7292V19.0179C28.7673 19.2725 28.6004 19.6572 28.1352 20.1265C27.6835 20.5822 27.0087 21.0568 26.1479 21.4876C24.4283 22.3481 22.0334 23.0001 19.3812 23.0001C16.729 23.0001 14.334 22.3483 12.6145 21.4879C11.7536 21.0571 11.0789 20.5825 10.6271 20.1268C10.162 19.6575 9.99512 19.2728 9.99512 19.0179V15.7292L19.0092 19.8331L19.0102 19.8335L19.173 19.9081Z",
    fill: "#AC8B68",
    stroke: "#AC8B68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5537 9.3235L19.381 17.5969L1.20676 9.3235L19.381 1.04938L37.5537 9.3235Z",
    fill: "#AC8B68",
    stroke: "#AC8B68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4214 16.8019L37.4198 16.7054C37.8286 16.4459 38.1425 15.943 38.1425 15.4201C38.1425 14.6883 37.6656 14.0506 36.9406 13.9357V9.68628H36.5555V11.8229V13.9595C35.878 14.1233 35.3154 14.6898 35.3154 15.3726C35.3154 15.8955 35.5136 16.351 35.9224 16.6105L35.8811 16.8011L34.4473 22.7646H36.6329H38.8177L37.4214 16.8019Z",
    fill: "#AC8B68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStudents);
export default __webpack_public_path__ + "static/media/total-students.cd32ae0310623f29ea581f42d40f8f7a.svg";
export { ForwardRef as ReactComponent };